module.exports = __webpack_public_path__ + "static/img/挂锁2.1d6b2c7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/guaLock/挂锁2.gif
// module id = 0+dD
// module chunks = 0